import {gql} from '@apollo/client';

export const activityQueries = {
    ACTIVITIES: gql`
        query {
            activities {
                nodes {
                    id
                    user
                    userId
                    activityDate
                    description
                    objectId
                    status
                    data
                    objectType
                    active
                    activityType
                }
            }
        }
    `,
    ACTIVITIES_BY_TYPE: gql`
        query activitiesByType($type: ActivityType!) {
            activitiesByType(type: $type) {
                id
                user
                userId
                activityDate
                description
                objectId
                status
                data
                objectType
                active
                activityType
            }
        }
    `,
    ACTIVITIES_BY_IDS: gql`
        query activitiesByIds($ids: [UUID!]!) {
            activitiesByIds(ids: $ids) {
                id
                user
                userId
                activityDate
                description
                objectId
                data
                status
                objectType
                active
                activityType
            }
        }
    `,
    ACTIVITIES_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        query activitiesByObjectIdAndObjectType(
            $objectId: UUID!
            $objectType: String!
            $after: String
            $first: Int
            $before: String
            $last: Int
            $where: ActivityViewModelFilterInput
            $order: [ActivityViewModelSortInput!]
        ) {
            activitiesByObjectIdAndObjectType(
                objectId: $objectId
                objectType: $objectType
                after: $after
                first: $first
                before: $before
                last: $last
                where: $where
                order: $order
            ) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    id
                    user
                    userId
                    activityDate
                    description
                    status
                    data
                    objectId
                    objectType
                    activityType
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    `,
};
